// src/services/itemsApi.js
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "services/api";
import { ListRequest, QRList, QRListDTO } from "./types";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}/qrlist`,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const qrListApi = createApi({
  reducerPath: "qrListService",
  baseQuery,
  tagTypes: ["QRList"],
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    getQRListByUserId: builder.query<QRList[], ListRequest>({
      query: (ListRequest: ListRequest) => ({
        url: `/user/${ListRequest.id}`,
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "QRList" as const,
                id,
              })),
              "QRList",
            ]
          : ["QRList"],
    }),

    getQRDetailById: builder.query<QRList, ListRequest>({
      query: (ListRequest: ListRequest) => ({
        url: `/${ListRequest.id}`,
        method: "GET",
      }),
    }),

    createQR: builder.mutation<any, QRListDTO>({
      query: (body: QRListDTO) => ({
        url: `/create`,
        method: "POST",
        body: JSON.stringify(body),
      }),
      invalidatesTags: ["QRList"],
    }),

    updateQR: builder.mutation<any, { id: number; body: QRListDTO }>({
      query: ({ id, body }) => ({
        url: `/${id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["QRList"],
    }),
  }),
});

export const {
  useGetQRListByUserIdQuery,
  useGetQRDetailByIdQuery,
  useCreateQRMutation,
  useUpdateQRMutation,
} = qrListApi;
